import { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout, { authStyles as s } from './components/AuthLayout';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await fetch('/api/auth/password-reset/request', {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Reset your password" subtitle="가입하신 이메일로 재설정 링크를 보내드립니다.">
      {sent ? (
        <>
          <p className={s.success}>입력하신 이메일로 재설정 링크를 보냈습니다. (계정이 존재한다면)</p>
          <Link to="/login" className={s.primary} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
            로그인으로 돌아가기
          </Link>
        </>
      ) : (
        <>
          <form onSubmit={onSubmit}>
            <div className={s.field}>
              <label className={s.label}>Email</label>
              <input className={s.input} type="email" placeholder="Email" required
                value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <button className={s.primary} type="submit" disabled={submitting}>
              {submitting ? '발송 중...' : '재설정 링크 받기'}
            </button>
          </form>
          <div className={s.forgot}>
            <Link to="/login">로그인으로 돌아가기</Link>
          </div>
        </>
      )}
    </AuthLayout>
  );
}
